import React from 'react';

const BasicFlag = (props) => {
  return (
    <span
      style={{
        backgroundColor: 'lightgray',
        borderRadius: '4px',
        padding: '2px 0.25rem',
        verticalAlign: 'middle',
        fontSize: '0.625rem',
      }}
    >
      BASIC
    </span>
  );
};

export default BasicFlag;
